import { DecorItemI } from "../../../../shared";
import { Box3, Vector3 } from "three";
import { useStoreRoom } from "../../../../store";
import { useEffect } from "react";
import { getWorkbenchToolboxSpec } from "../../../../utils/workbenchToolbox";

function useInitDecor(decor: DecorItemI, box: Box3) {
    const updateDecor = useStoreRoom((state) => state.updateDecor);

    const size = box.getSize(new Vector3());
    const workbenchToolboxSpec = getWorkbenchToolboxSpec(decor);
    const initialSize = workbenchToolboxSpec
        ? new Vector3(workbenchToolboxSpec.width, workbenchToolboxSpec.height, workbenchToolboxSpec.depth)
        : size;

    useEffect(() => {
        if (!decor.initialized) {
            const positionZ =
                decor.side === "front"
                    ? decor.position[2] + (decor.name === "Ворота" ? 0 : initialSize.z / 2)
                    : decor.side === "back"
                    ? decor.position[2] - (decor.name === "Ворота" ? 0 : initialSize.z / 2)
                    : decor.position[2];
            const positionX =
                decor.side === "left"
                    ? decor.position[0] + (decor.name === "Ворота" ? 0 : initialSize.z / 2)
                    : decor.side === "right"
                    ? decor.position[0] - (decor.name === "Ворота" ? 0 : initialSize.z / 2)
                    : decor.position[0];

            const positionY =
                decor.type !== "doors" && decor.surface === "wall" ? decor.position[1] : initialSize.y / 2;

            updateDecor({
                ...decor,
                initialized: true,
                width: initialSize.x,
                height: initialSize.y,
                depth: initialSize.z,
                position: [positionX, positionY, positionZ],
                translate: [0, initialSize.y / 2, 0],
            });
        }
    }, []);

    const scale = decor.initialized ? [decor.width / size.x, decor.height / size.y, decor.depth / size.z] : [1, 1, 1];

    return {
        scale,
    };
}

export default useInitDecor;
